import {AppState} from '@/store/state';
import {ToggleControlSidebar, ToggleSidebarMenu, ToggleTaskSidebar} from '@/store/ui/actions';
import {UiState} from '@/store/ui/state';
import {Component, HostBinding, OnInit} from '@angular/core';
import {UntypedFormGroup, UntypedFormControl} from '@angular/forms';
import {Store} from '@ngrx/store';
import {AppService} from '@services/app.service';
import {NotificationService} from '@services/notification.service';
import {Observable, Subscription} from 'rxjs';

const BASE_CLASSES = '';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public searchForm: UntypedFormGroup;
    notifications: any[] = [];
    notificationCount: number = 0;
    pollingSubscription: Subscription;
    userDetail: any;

    constructor(
        private appService: AppService,
        private store: Store<AppState>
    ) {}

    ngOnInit() {
        const pollingInterval = 60000;
        this.ui = this.store.select('ui');
        this.ui.subscribe((state: UiState) => {
            this.classes = `${BASE_CLASSES} ${state.navbarVariant}`;
        });
        this.searchForm = new UntypedFormGroup({
            search: new UntypedFormControl(null)
        });

        // const currentUser = localStorage.getItem('UserDetail');
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
    }

    logout() {
        this.appService.logout();
    }

    onToggleMenuSidebar() {
        this.store.dispatch(new ToggleSidebarMenu());
    }

    onToggleControlSidebar() {
        this.store.dispatch(new ToggleControlSidebar());
    }

    onToggleTaskSidebar() {
        this.store.dispatch(new ToggleTaskSidebar());
    }

    visible: boolean = false;
    closeDropdown() {
        this.visible = !this.visible;
    }
    closeDropdownmain() {
        this.visible = true;
    }
}
